import { RegistrationForm } from "src/page-components/auth/RegistrationForm";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const Registration = () => (
  <MetadataWrapper name="registration">
    <PageWrapper>
      <section className="container py-25 !overflow-visible">
        <RegistrationForm />
      </section>
    </PageWrapper>
  </MetadataWrapper>
);
export default Registration;
